<template>
  <v-data-table
    :headers="headersByType"
    :items="items"
    :search="search"
    :sort-by="['date_conflict']"
    :sort-desc="false"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        :label="$t('DATA_TABLE.SEARCH')"
        outlined
        append-icon="mdi-magnify"
      />
    </template>

    <template v-slot:item.date_conflict="{ item }">
      {{ item.date_conflict | dateFormat }}
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('show', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
export const VACATIONS = 'vacations';
export const HOLIDAYS = 'holidays';

export const types = Object.freeze({
  VACATIONS,
  HOLIDAYS
});

export default {
  name: 'ConflictsList',

  filters: {
    dateFormat
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'vacations',
      validator: prop => Object.values(types).includes(prop)
    }
  },

  data: () => ({
    search: '',
    columnsByType: {
      vacations: [0, 1, 2, 3, 4],
      holidays: [0, 1, 3, 4]
    }
  }),

  computed: {
    headersByType() {
      const columnsIndexes = this.columnsByType[this.type];

      return this.headers.filter((item, index) => {
        return columnsIndexes.indexOf(index) !== -1;
      });
    },
    headers() {
      return [
        {
          text: this.$t('EMPLOYEES.FIRST_NAME'),
          value: 'first_name'
        },
        {
          text: this.$t('EMPLOYEES.LAST_NAME'),
          value: 'last_name'
        },
        {
          text: this.$t('ITEM.ADDITIONAL_INFO'),
          value: 'additional_info'
        },
        {
          text: this.$t('DASHBOARD.DATE_OF_CONFLICTS'),
          align: 'left',
          sortable: true,
          value: 'date_conflict'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  }
};
</script>
